module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-197.fcbf0ae4.svg";